let bootstrapCssPromise;

/**
 * Load Bootstrap CSS on demand so it stays off the initial critical path.
 * Safe to call multiple times.
 */
export function loadBootstrapCss() {
  if (bootstrapCssPromise) return bootstrapCssPromise;
  bootstrapCssPromise = import("bootstrap/dist/css/bootstrap.min.css");
  return bootstrapCssPromise;
}

/**
 * Defer large legacy stylesheets that are not required for first paint
 * of the public shell (header + landing/login design system).
 */
export function loadLegacyAppCss() {
  return Promise.all([
    import("../App.css"),
    import("../Appp.css"),
    import("../Sahiltest.css"),
  ]);
}
